import axios from './axios'

class DownloadServiceClass {
  async jubileeOrder (type: 'download' | 'print', id: number) {
    await this[type](`/api/jubilee/orders/${id}/download`, 'objednavka.pdf')
  }

  async download (url: string, fileName: string, queryParams: { [key: string]: string | number } = {}) {
    const res = await axios.get(url, {
      responseType: 'blob',
      params: queryParams
    })

    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  async print (url: string, fileName: string, queryParams: { [key: string]: string | number } = {}) {
    const res = await axios.get(url, {
      responseType: 'blob',
      params: queryParams
    })

    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}

const DownloadService = new DownloadServiceClass()

export {
  DownloadService
}
